import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { FAQS, SITE } from "../lib/site";
import SectionHeader from "../components/SectionHeader";
import Seo from "../components/Seo";
import { Link } from "react-router-dom";

export default function FAQ() {
    const [open, setOpen] = useState(0);
    return (
        <div data-testid="faq-page">
            <Seo
                title="FAQ — Common Questions About Working With a Builder"
                description="Insurance, planning permission, fixed-price quotes, guarantees — everything you probably want to know before starting your project."
                path="/faq"
            />
            <section className="bg-muted border-b border-border">
                <div className="container-x py-20 md:py-28">
                    <SectionHeader
                        eyebrow="FAQ"
                        title="Questions, answered."
                        lead="Everything you've probably been wondering about working with a builder. Can't see your question? Just ask."
                    />
                </div>
            </section>

            <section className="section-pad container-x grid md:grid-cols-12 gap-12">
                <div className="md:col-span-8">
                    <div className="divide-y divide-border">
                        {FAQS.map((f, i) => {
                            const isOpen = open === i;
                            return (
                                <div key={i} data-testid={`faq-${i}`}>
                                    <button
                                        onClick={() => setOpen(isOpen ? -1 : i)}
                                        className="w-full text-left py-6 flex items-start justify-between gap-6 group"
                                        data-testid={`faq-toggle-${i}`}
                                    >
                                        <span className={`font-heading text-lg md:text-xl font-bold tracking-tight ${isOpen ? "text-primary" : "text-foreground"}`}>
                                            {f.q}
                                        </span>
                                        <span className={`shrink-0 h-9 w-9 rounded-full grid place-items-center transition-colors ${isOpen ? "bg-primary text-primary-foreground" : "bg-muted text-foreground"}`}>
                                            {isOpen ? <Minus size={16} /> : <Plus size={16} />}
                                        </span>
                                    </button>
                                    {isOpen && (
                                        <div className="pb-6 text-muted-foreground leading-relaxed max-w-2xl" data-testid={`faq-answer-${i}`}>
                                            {f.a}
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
                <aside className="md:col-span-4">
                    <div className="bg-primary text-primary-foreground rounded-lg p-8 sticky top-28">
                        <h3 className="font-heading text-2xl font-bold">Still got questions?</h3>
                        <p className="mt-3 text-sm opacity-85 leading-relaxed">
                            Always happy to chat — no pressure, no sales pitch. Pick up the phone or drop us a line.
                        </p>
                        <a href={SITE.phoneLink} className="block mt-6 bg-secondary text-secondary-foreground px-6 py-3.5 rounded-md font-medium text-center hover:bg-secondary-hover transition-colors" data-testid="faq-call-btn">
                            Call {SITE.phone}
                        </a>
                        <Link to="/contact" className="block mt-3 border-2 border-white/40 text-white px-6 py-3.5 rounded-md font-medium text-center hover:bg-white hover:text-primary transition-colors" data-testid="faq-message-btn">
                            Send a message
                        </Link>
                    </div>
                </aside>
            </section>
        </div>
    );
}
